import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'La sucursal representa una sede o base de la empresa. Cada obra pertenece a una sucursal fija, y el equipo hereda automáticamente la sucursal de la obra en la que está trabajando.',
    'Sirve para separar la flota por delegación cuando la operación abarca varias regiones que se gestionan independientemente.',
    'Si trabajás con una sola sede, alcanza con crear una y asignarla a todas las obras.',
  ],
  nextSteps: [
    'Asignar la sucursal correspondiente a cada obra desde Configuración → Obras.',
    'Los informes permiten filtrar los resultados por sucursal.',
    'Asignar una sucursal a un usuario, puede permitir que el mismo gestione equipos pertenecientes solo a esa sucursal.',
  ],
};

const ConfiguracionSucursales = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="sucursales"
      titulo="Sucursales"
      descripcion="Ubicaciones y oficinas de la empresa"
      icon="fas fa-store"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionSucursales;